var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.opt[0])?_c('div',[_c('tree-select',{attrs:{"options":_vm.opt,"disable-branch-nodes":true,"show-count":true,"placeholder":"请选择基金小镇"},on:{"select":_vm.selectFcode}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }